import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function formatDateTime(isoString) {
  if (!isoString) return null;
  const parsed = new Date(isoString);
  if (Number.isNaN(parsed.getTime())) return isoString;
  return parsed.toLocaleString('en-GB', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export default function FluidPrescriptionCard({ fluid, prescribingStatus, onEdit, onStop, onRestart }) {
  const isStopped = fluid.status === 'stopped';
  const endDate = fluid.end_date ? new Date(fluid.end_date) : null;
  const isComplete = endDate && endDate <= new Date() && !isStopped;

  return (
    <Card className={`mt-2 rounded border${isStopped ? ' opacity-75' : ''}`}>
      <Card.Body className="py-2 px-3">
        <Row className="align-items-center g-2">
          <Col xs={12} md={5}>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <strong>{fluid.drug}</strong>
              {isStopped && <Badge bg="secondary">Stopped</Badge>}
              {isComplete && <Badge bg="success">Complete</Badge>}
            </div>
            {fluid.additives?.length > 0 && (
              <div className="text-muted small">
                + {fluid.additives.join(', ')}
              </div>
            )}
            {fluid.indication && (
              <div className="text-muted small">For: {fluid.indication}</div>
            )}
          </Col>

          <Col xs={6} md={3}>
            <div className="small">
              <div>
                <strong>{fluid.volumeMl} mL</strong>
                {fluid.rateMlPerHour ? <span className="text-muted"> at {fluid.rateMlPerHour} mL/hr</span> : null}
              </div>
              {fluid.durationHours ? (
                <div className="text-muted">Over {fluid.durationHours} hour{fluid.durationHours !== 1 ? 's' : ''}</div>
              ) : null}
            </div>
          </Col>

          <Col xs={6} md={2}>
            <div className="small text-muted">
              {fluid.start_date && <div>Start: {formatDateTime(fluid.start_date)}</div>}
              {endDate && <div>End: {formatDateTime(fluid.end_date)}</div>}
            </div>
          </Col>

          {prescribingStatus && (
            <Col xs={12} md={2} className="d-flex justify-content-end gap-1 flex-wrap">
              {!isStopped && (
                <>
                  <Button size="sm" variant="outline-primary" onClick={onEdit}>Edit</Button>
                  <Button size="sm" variant="outline-danger" onClick={onStop}>Stop</Button>
                </>
              )}
              {isStopped && (
                <Button size="sm" variant="outline-secondary" onClick={onRestart}>Restart</Button>
              )}
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
}
